<canvas id="teamCanvas" width="600" height="500"></canvas>
<!-- Creates the hexagons with ng-repeat instead manually
<div class="hexagon active" ng-class="{'city-one': $index===0, 'city-two': $index===4, 'city-three': $index===2, 'city-four': $index===3, 'city-five': $index===5, 'city-six': $index===1}" ng-repeat="team in orderedTeams">
    <div class="chart-container chart-container-activity">
      <div class="chart-bar wrapper">
        <div class="chart-bar topscorer" [ngStyle]="{'height':calculateTopscorer(team.scores.top_scorer.total, team.scores.top_scorer.number).activity}"></div>
      </div>
      <div class="chart-bar wrapper">
        <div class="chart-bar sparkcreator" [ngStyle]="{'height':calculateSparkcreator(team.scores.spark_creator.total, team.scores.spark_creator.number).activity}"></div>
      </div>
      <div class="chart-bar wrapper">
        <div class="chart-bar improver" [ngStyle]="{'height':calculateImprover(team.scores.improver.total, team.scores.improver.number).activity}"></div>
      </div>
      <div class="chart-bar wrapper" *ngIf="session.config.benefits_and_challenges">
        <div class="chart-bar challenger" [ngStyle]="{'height': calculateChallenger(team.scores.challenger.number).activity}"></div>
      </div>
      <div class="chart-bar wrapper" *ngIf="session.config.benefits_and_challenges">
        <div class="chart-bar sunshine" [ngStyle]="{'height':calculateSunshine(team.scores.sunshine.number).activity}"></div>
      </div>
      <div class="chart-bar wrapper" *ngIf="session.config.benefits_and_challenges && session.config.solutions">
        <div class="chart-bar solutionfinder" [ngStyle]="{'height':calculateSolutionfinder(team.scores.solution_finder.number).activity}"></div>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-bar wrapper">
        <div class="chart-bar topscorer" [ngStyle]="{'height':calculateTopscorer(team.scores.top_scorer.total, team.scores.top_scorer.number).performance}"></div>
      </div>
      <div class="chart-bar wrapper">
        <div class="chart-bar sparkcreator" [ngStyle]="{'height':calculateSparkcreator(team.scores.spark_creator.total, team.scores.spark_creator.number).performance}"></div>
      </div>
      <div class="chart-bar wrapper">
        <div class="chart-bar improver" [ngStyle]="{'height':calculateImprover(team.scores.improver.total, team.scores.improver.number).performance}"></div>
      </div>
      <div class="chart-bar wrapper" *ngIf="session.config.benefits_and_challenges">
        <div class="chart-bar challenger" [ngStyle]="{'height': calculateChallenger(team.scores.challenger.number).performance}"></div>
      </div>
      <div class="chart-bar wrapper" *ngIf="session.config.benefits_and_challenges">
        <div class="chart-bar sunshine" [ngStyle]="{'height':calculateSunshine(team.scores.sunshine.number).performance}"></div>
      </div>
      <div class="chart-bar wrapper" *ngIf="session.config.benefits_and_challenges && session.config.solutions">
        <div class="chart-bar solutionfinder" [ngStyle]="{'height':calculateSolutionfinder(team.scores.solution_finder.number).performance}"></div>
      </div>
    </div>
  -->
<div class="hexagon city-one active" *ngIf="orderedTeams[0]">
  <div class="chart-container chart-container-activity">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[0].scores.top_scorer.total,
            orderedTeams[0].scores.top_scorer.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[0].scores.spark_creator.total,
            orderedTeams[0].scores.spark_creator.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[0].scores.improver.total,
            orderedTeams[0].scores.improver.number
          ).activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[0].scores.challenger.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[0].scores.sunshine.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[0].scores.solution_finder.number
          ).activity,
        }"></div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[0].scores.top_scorer.total,
            orderedTeams[0].scores.top_scorer.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[0].scores.spark_creator.total,
            orderedTeams[0].scores.spark_creator.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[0].scores.improver.total,
            orderedTeams[0].scores.improver.number
          ).performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[0].scores.challenger.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[0].scores.sunshine.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[0].scores.solution_finder.number
          ).performance,
        }"></div>
    </div>
  </div>

  <div class="team-label">
    {{ orderedTeams[0].name }}
  </div>
</div>
<div class="hexagon city-two" *ngIf="orderedTeams[4]">
  <div class="chart-container chart-container-activity">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[4].scores.top_scorer.total,
            orderedTeams[4].scores.top_scorer.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[4].scores.spark_creator.total,
            orderedTeams[4].scores.spark_creator.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[4].scores.improver.total,
            orderedTeams[4].scores.improver.number
          ).activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[4].scores.challenger.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[4].scores.sunshine.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[4].scores.solution_finder.number
          ).activity,
        }"></div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[4].scores.top_scorer.total,
            orderedTeams[4].scores.top_scorer.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[4].scores.spark_creator.total,
            orderedTeams[4].scores.spark_creator.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[4].scores.improver.total,
            orderedTeams[4].scores.improver.number
          ).performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[4].scores.challenger.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[4].scores.sunshine.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[4].scores.solution_finder.number
          ).performance,
        }"></div>
    </div>
  </div>

  <div class="team-label">
    {{ orderedTeams[4].name }}
  </div>
</div>
<div class="hexagon city-three" *ngIf="orderedTeams[2]">
  <div class="chart-container chart-container-activity">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[2].scores.top_scorer.total,
            orderedTeams[2].scores.top_scorer.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[2].scores.spark_creator.total,
            orderedTeams[2].scores.spark_creator.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[2].scores.improver.total,
            orderedTeams[2].scores.improver.number
          ).activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[2].scores.challenger.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[2].scores.sunshine.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[2].scores.solution_finder.number
          ).activity,
        }"></div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[2].scores.top_scorer.total,
            orderedTeams[2].scores.top_scorer.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[2].scores.spark_creator.total,
            orderedTeams[2].scores.spark_creator.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[2].scores.improver.total,
            orderedTeams[2].scores.improver.number
          ).performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[2].scores.challenger.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[2].scores.sunshine.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[2].scores.solution_finder.number
          ).performance,
        }"></div>
    </div>
  </div>
  <div class="team-label">
    {{ orderedTeams[2].name }}
  </div>
</div>
<div class="hexagon city-four" *ngIf="orderedTeams[3]">
  <div class="chart-container chart-container-activity">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[3].scores.top_scorer.total,
            orderedTeams[3].scores.top_scorer.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[3].scores.spark_creator.total,
            orderedTeams[3].scores.spark_creator.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[3].scores.improver.total,
            orderedTeams[3].scores.improver.number
          ).activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[3].scores.challenger.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[3].scores.sunshine.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[3].scores.solution_finder.number
          ).activity,
        }"></div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[3].scores.top_scorer.total,
            orderedTeams[3].scores.top_scorer.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[3].scores.spark_creator.total,
            orderedTeams[3].scores.spark_creator.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[3].scores.improver.total,
            orderedTeams[3].scores.improver.number
          ).performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[3].scores.challenger.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[3].scores.sunshine.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[3].scores.solution_finder.number
          ).performance,
        }"></div>
    </div>
  </div>

  <div class="team-label">
    {{ orderedTeams[3].name }}
  </div>
</div>
<div class="hexagon city-five" *ngIf="orderedTeams[5]">
  <div class="chart-container chart-container-activity">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[5].scores.top_scorer.total,
            orderedTeams[5].scores.top_scorer.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[5].scores.spark_creator.total,
            orderedTeams[5].scores.spark_creator.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[5].scores.improver.total,
            orderedTeams[5].scores.improver.number
          ).activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[5].scores.challenger.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[5].scores.sunshine.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[5].scores.solution_finder.number
          ).activity,
        }"></div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[5].scores.top_scorer.total,
            orderedTeams[5].scores.top_scorer.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[5].scores.spark_creator.total,
            orderedTeams[5].scores.spark_creator.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[5].scores.improver.total,
            orderedTeams[5].scores.improver.number
          ).performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[5].scores.challenger.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[5].scores.sunshine.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[5].scores.solution_finder.number
          ).performance,
        }"></div>
    </div>
  </div>

  <div class="team-label">
    {{ orderedTeams[5].name }}
  </div>
</div>
<div class="hexagon city-six" *ngIf="orderedTeams[1]">
  <div class="chart-container chart-container-activity">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[1].scores.top_scorer.total,
            orderedTeams[1].scores.top_scorer.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[1].scores.spark_creator.total,
            orderedTeams[1].scores.spark_creator.number
          ).activity,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[1].scores.improver.total,
            orderedTeams[1].scores.improver.number
          ).activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[1].scores.challenger.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[1].scores.sunshine.number)
            .activity,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[1].scores.solution_finder.number
          ).activity,
        }"></div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-bar wrapper">
      <div
        class="chart-bar topscorer"
        [ngStyle]="{
          height: calculateTopscorer(
            orderedTeams[1].scores.top_scorer.total,
            orderedTeams[1].scores.top_scorer.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar sparkcreator"
        [ngStyle]="{
          height: calculateSparkcreator(
            orderedTeams[1].scores.spark_creator.total,
            orderedTeams[1].scores.spark_creator.number
          ).performance,
        }"></div>
    </div>
    <div class="chart-bar wrapper">
      <div
        class="chart-bar improver"
        [ngStyle]="{
          height: calculateImprover(
            orderedTeams[1].scores.improver.total,
            orderedTeams[1].scores.improver.number
          ).performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar challenger"
        [ngStyle]="{
          height: calculateChallenger(orderedTeams[1].scores.challenger.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="session.config.benefits_and_challenges">
      <div
        class="chart-bar sunshine"
        [ngStyle]="{
          height: calculateSunshine(orderedTeams[1].scores.sunshine.number)
            .performance,
        }"></div>
    </div>
    <div
      class="chart-bar wrapper"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div
        class="chart-bar solutionfinder"
        [ngStyle]="{
          height: calculateSolutionfinder(
            orderedTeams[1].scores.solution_finder.number
          ).performance,
        }"></div>
    </div>
  </div>

  <div class="team-label">
    {{ orderedTeams[1].name }}
  </div>
</div>

<div class="legend">
  <h4>Legend:</h4>
  <div class="chart-container">
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Top scorer">
      <div class="chart-bar topscorer" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Spark creator">
      <div class="chart-bar sparkcreator" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Improver">
      <div class="chart-bar improver" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Challenger"
      *ngIf="session.config.benefits_and_challenges">
      <div class="chart-bar challenger" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Sunshine"
      *ngIf="session.config.benefits_and_challenges">
      <div class="chart-bar sunshine" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Solution finder"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div class="chart-bar solutionfinder" style="height: 40px"></div>
    </div>
    <span>Performance</span>
  </div>
  <div class="chart-container chart-container-activity">
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Top scorer">
      <div class="chart-bar topscorer" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Spark creator">
      <div class="chart-bar sparkcreator" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Improver">
      <div class="chart-bar improver" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Challenger"
      *ngIf="session.config.benefits_and_challenges">
      <div class="chart-bar challenger" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Sunshine"
      *ngIf="session.config.benefits_and_challenges">
      <div class="chart-bar sunshine" style="height: 40px"></div>
    </div>
    <div
      class="chart-bar wrapper"
      placement="top"
      [hide-delay]="100"
      tooltip="Solution finder"
      *ngIf="
        session.config.benefits_and_challenges && session.config.solutions
      ">
      <div class="chart-bar solutionfinder" style="height: 40px"></div>
    </div>
    <span>Activity</span>
  </div>
</div>
